import React from "react";
import { blogData } from "../../data/BlogData";
import { useParams } from "react-router-dom";

const BlogDetails = () => {
  const { id } = useParams();

  console.log("ididid", id);

  const filteredData = blogData?.find((data) => data?.id === id);

  if (!filteredData) {
    return <div>Blog not found.</div>;
  }

  return (
    <div className="blog_container" style={{ marginTop: 80 }}>
      {filteredData?.image && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignSelf: "center",
            marginBottom: 40,
          }}
        >
          <img
            src={filteredData?.image}
            alt="cover"
            style={{ height: 400, width: "90vw" }}
          />
        </div>
      )}
      {filteredData?.content?.map((data, index) => {
        return (
          <div key={index} style={{ padding: "0px 16px" }}>
            <div className="blog_title" style={{ marginBottom: 20 }}>
              {data?.title}
            </div>
            <div className="terms_content_points" style={{ marginBottom: 20 }}>
              {data?.content}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BlogDetails;
